export default "__VITE_ASSET__e109064c__"